import { VoucherProduct } from "~/server/types/brand";

export function defaultRequestForAVariantBrand(brand?: VoucherProduct) {
  const defaultVariant =
    brand?.variantDetailedResponse?.find((variant) => variant.isDefault) ??
    brand?.variantDetailedResponse?.at(0);

  return {
    variantId: defaultVariant?.variantId ?? "",
    amount: defaultVariant?.amount ?? 1000,
    voucherProductId: brand?.externalId ?? "",
  };
}

export function defaultRequestForADenominationsBrand(brand?: VoucherProduct) {
  const defaultDenomination =
    brand?.amountConditions.defaultDenominationDetails?.at(0)?.denomination ??
    brand?.amountConditions.denominations?.at(0) ??
    brand?.amountConditions.defaultAmount;
  return {
    amount: defaultDenomination ?? 1000,
    voucherProductId: brand?.externalId ?? "",
  };
}
